import cloneDeep from 'lodash.clonedeep';
import { put, select } from 'redux-saga/effects';

import { SetSceneTransitionConfigAction } from 'js/actionCreators/sceneTransitionsActions';
import { updateScribe } from 'js/actionCreators/scribeActions';

import { getScribeById } from '../selectors';

import { getActiveSceneIds } from './getActiveSceneIds';

export function* setSceneTransitionConfig({ config, scribeId, sceneIds }: SetSceneTransitionConfigAction) {
  const scribe = (yield select(getScribeById, scribeId)) as ReturnType<typeof getScribeById>;

  if (!scribe) return;

  const updatedScribe = cloneDeep(scribe);

  let sceneIdsToUse = getActiveSceneIds(scribe, sceneIds);

  if (!sceneIdsToUse) {
    return;
  }

  let hasUpdated = false;

  sceneIdsToUse.forEach(sceneId => {
    const scene = updatedScribe.scenes.find(scene => scene.id === sceneId);

    if (!scene) return;

    hasUpdated = true;

    let newConfig = { ...config };

    if (scene.settings.sceneTransitionType === 'drag-on') {
      newConfig = {
        ...scene.settings.sceneTransitionConfig,
        ...newConfig
      };
    }

    scene.settings = {
      ...scene.settings,
      sceneTransitionConfig: newConfig
    };
  });

  if (!hasUpdated) {
    return;
  }

  yield put(updateScribe(updatedScribe));
}
